import { mechanicApi } from 'widgets/mechanic/api/mechanicApi';

type MechanicType = {
  id: number | 0;
  name: string | null;
  description: string | null;
  is_active: boolean | false;
  status: string | null;
};

export type MechanicsListType = {
  items: MechanicType[];
  total: number;
  page: number;
  size: number;
};

type CreateMechanicResponseType = {
  id: number | 0;
  name: string | null;
  description: string | null;
};

export type BonusListType = {
  name: string;
  id: number;
};

const getMechanicApi = mechanicApi.injectEndpoints({
  endpoints: (builder) => ({
    getMechanic: builder.query<
      MechanicsListType,
      {
        app_type: string;
        search: string;
        page: number;
        size: number;
        calculation_function: number[];
        is_active: boolean[];
      }
    >({
      query: ({ app_type, search, page, size, calculation_function, is_active }) => ({
        url:
          calculation_function.length && is_active.length
            ? `/promo-b2b/${app_type}/promo-b2b/admin/objectives/?page=${page}&size=${size}&search=${search}&calculation_function=${calculation_function}&is_active=${is_active}&order_by=-id`
            : calculation_function.length && !is_active.length
            ? `/promo-b2b/${app_type}/promo-b2b/admin/objectives/?page=${page}&size=${size}&search=${search}&calculation_function=${calculation_function}&order_by=-id`
            : !calculation_function.length && !is_active.length
            ? `/promo-b2b/${app_type}/promo-b2b/admin/objectives/?page=${page}&size=${size}&search=${search}&order_by=-id`
            : `/promo-b2b/${app_type}/promo-b2b/admin/objectives/?page=${page}&size=${size}&search=${search}&is_active=${is_active}&order_by=-id`,
      }),
      providesTags: ['Mechanics'],
    }),
    createMechanic: builder.query<CreateMechanicResponseType, { app_type: string; body: any }>({
      query: ({ app_type, body }) => {
        console.log('Creating mechanic with body:', body);
        return {
          url: `/promo-b2b/${app_type}/promo-b2b/admin/objectives/`,
          method: 'POST',
          body,
        };
      },
      providesTags: ['Response'],
    }),
    getBonus: builder.query<BonusListType[], any>({
      query: () => '/promo-b2b/admin/promo-b2b/admin/bonus-withdraw-types/',
    }),
    getBonusId: builder.query<BonusListType, number>({
      query: (id) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/bonus-withdraw-types/${id}/`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetMechanicQuery, useCreateMechanicQuery, useGetBonusQuery, useGetBonusIdQuery } = getMechanicApi;
